import PropTypes from 'prop-types';

import Access from './Access';
import Instructions from './Instructions';

import { useSelector } from '../../../redux/store';

const InstructionsAndAccess = ({ hiddenInstructionProfile = false, isModal = false, site }) => {
  const { isLoading } = useSelector((state) => state.sites);
  const { profile } = useSelector((state) => state.profiles);

  return (
    <>
      <Instructions
        hiddenInstructionProfile={hiddenInstructionProfile}
        loading={isLoading}
        isModal={isModal}
        instructionsSite={site.instructions}
        instructionsProfile={profile.instructions}
      />
      <Access access={site.access} isModal={isModal} loading={isLoading} title="Accès" />
    </>
  );
};

InstructionsAndAccess.propTypes = {
  hiddenInstructionProfile: PropTypes.bool,
  isModal: PropTypes.bool,
  site: PropTypes.object
};

export default InstructionsAndAccess;
